import React from 'react';
import { Tooltip, Typography } from 'antd';
import { ExportOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './QuickLinkCard.module.scss';
import { QUICK_LINK_ICON_MAPPER } from '@/constant/quickLinkIconMapper';
interface QuickLinkCardProps {
  id: string;
  title: string;
  description: string;
  link: string;
  onDelete: (id: string) => void;
}

const QuickLinkCard: React.FC<QuickLinkCardProps> = ({
  id,
  title,
  description,
  link,
  onDelete,
}) => {
  return (
    <Tooltip title={description} mouseEnterDelay={0.2} mouseLeaveDelay={0}>
      <div className={styles.card}>
        <div
          className={styles.link}
          onClick={() => window.open(link, '_blank')}
        >
          <div className={styles.icon}>{QUICK_LINK_ICON_MAPPER[link]}</div>
          <Typography.Text className={styles.title} ellipsis>
            {title}
          </Typography.Text>
        </div>
        <DeleteOutlined
          className={styles.delete}
          onClick={() => onDelete(id)}
        />
      </div>
    </Tooltip>
  );
};

export default QuickLinkCard;
